import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

import { Virtuoso } from 'react-virtuoso';

import Loader from 'components/loader';
import NotFound from 'components/not-found';
import { ButtonProps } from 'components/button';
import BaseScreen from 'components/base-screen';
import ErrorMessage from 'components/error-message';
import { ApartmentNavigateProps } from 'screens/apartment';
import LoadMoreVirtualListFooter from 'components/load-more-virtual-list-footer';
import RequestListItem, { REQUEST_LIST_ITEM_HEIGHT } from 'components/request-list-item';

import { BuyApartmentFlowPaths } from 'routes';
import { ITEMS_PER_PAGE } from 'lib/constants';
import useRequests from 'api/hooks/use-requests';
import useVirtualListStyle from 'hooks/use-virtial-list-style';

import styles from './styles.module.scss';

const Requests: React.FC = () => {
  const navigate = useNavigate();

  const listStyle = useVirtualListStyle();

  const { data: requests, total, error, setSize, isInitialLoading, isLoadingMore } = useRequests();

  // const buttons: ButtonProps[] = [
  //   {
  //     label: 'Позвонить',
  //   },
  // ];

  return (
    <BaseScreen title='Запросы' buttons={[]}>
      {error && requests.length === 0 ? (
        <ErrorMessage className={styles.margined} message={error} />
      ) : isInitialLoading ? (
        <Loader className={styles.margined} />
      ) : requests.length > 0 ? (
        <Virtuoso
          useWindowScroll
          context={{
            total,
            loading: isLoadingMore,
            per: ITEMS_PER_PAGE,
            loadedNum: requests.length,
            loadMore: () => setSize((s) => s + 1),
          }}
          data={requests}
          style={listStyle}
          className={styles.container}
          defaultItemHeight={REQUEST_LIST_ITEM_HEIGHT}
          itemContent={(index, request) => (
            <RequestListItem
              request={request}
              onClick={() => {
                navigate(BuyApartmentFlowPaths.apartment, {
                  state: {
                    id: request.facility.id,
                  } as ApartmentNavigateProps,
                });
              }}
              className={clsx(index !== requests.length - 1 && styles.border)}
            />
          )}
          components={{ Footer: LoadMoreVirtualListFooter }}
        />
      ) : (
        <NotFound />
      )}
    </BaseScreen>
  );
};

export default Requests;
